import { EmployeeApplyLateProps } from '../../../../types/Leaves/ApplyLateArrival/employeeApplyLateTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { employeeApplyLateApiConfig, AllowedHttpMethods } from '../../apiList'

const regularization = async (
  prepareObject: EmployeeApplyLateProps,
): Promise<number | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeApplyLateApiConfig.regularization,
    method: AllowedHttpMethods.post,
    data: prepareObject,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const employeeApplyLateApi = {
  regularization,
}

export default employeeApplyLateApi
